import { render } from "./DJDashboard.vue?vue&type=template&id=1577c564"
import script from "./DJDashboard.vue?vue&type=script&lang=js"
export * from "./DJDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script